// extracted by mini-css-extract-plugin
export default {"cls1":"EGKQ5lzMmqWMjXJ6J06g","cls2":"_qppgRGOTwQVwy2JeHKt EGKQ5lzMmqWMjXJ6J06g"};